import React from 'react';
import styles from './Dashboard.module.css';

export default function Dashboard() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Dashboard</h1>
      <div className={styles.subtitle}>Track patients, treatment plans, and generated presentations in one glance.</div>
      <div className={styles.cards}>
        <div className={styles.card}><div className={styles.cardTitle}>Patients</div><div className={styles.cardValue}>0</div></div>
        <div className={styles.card}><div className={styles.cardTitle}>Tx Plan Items</div><div className={styles.cardValue}>0</div></div>
        <div className={styles.card}><div className={styles.cardTitle}>Status Breakdown</div><div className={styles.cardSub}>No data yet</div></div>
      </div>
    </div>
  );
}

